import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class StateStorageService {
  save<T>(key: string, state: T): void {
    sessionStorage.setItem(key, JSON.stringify(state));
  }

  load<T>(key: string): T | null {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  clear(key: string): void {
    sessionStorage.removeItem(key);
  }
}
